import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppPriceChangeComparisonAlertAutocomplete } from "@components/Autocomplete"


export default function ReportPriceChangeAlertField() {
	const {
		conditionsPriceChange,
		setConditionsPriceChangeInfo,
		error
	} = useReportFormInfo(reportFormData.peek().conditionsPriceChange || [], "conditionsPriceChange", object({ conditionsPriceChange: array().nullable() }))

	return <AppPriceChangeComparisonAlertAutocomplete
		multiple
		value={conditionsPriceChange}
		onChange={e => setConditionsPriceChangeInfo(e.target.value)}
		error={error}
	/>
}